import {
  clearLoggedInUserEmail,
  clearLegacySearchSessionStorage,
} from "./searchSessionStorage";
import { clearRecommendationsPageCache } from "./recommendationsPageCache";
import { clearSavedPageCache } from "./savedPageCache";

/** Clear tokens, user-scoped caches, and navigate to login. */
export function signOut(navigate) {
  localStorage.removeItem("authToken");
  localStorage.removeItem("refreshToken");
  clearLoggedInUserEmail();
  clearLegacySearchSessionStorage();
  clearRecommendationsPageCache();
  clearSavedPageCache();
  navigate("/login");
}
